import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["Component"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import { autoUpdate, flip, offset, shift, useFloating, useClick, useDismiss, useInteractions, FloatingPortal } from '@floating-ui/react';
import { createContext, forwardRef, useCallback, useContext, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import breakpoints from '@/config/breakpoints';
import useComposedRefs from '@/hooks/useComposeRefs';
import { ButtonV2 as Button } from '@/components/Button';
import { Drawer, DrawerContent } from '@/components/FormElements/internal/Drawer';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DropdownContext = /*#__PURE__*/createContext({
  isOpen: false,
  isMobile: false,
  onOpenChange: () => null,
  // Floating UI
  floatingStyles: {},
  setReference: () => null,
  setFloating: () => null,
  getReferenceProps: () => ({}),
  getFloatingProps: () => ({})
});

const Dropdown = _ref => {
  let {
    placement = 'top-start',
    children,
    onOpenChange
  } = _ref;
  const {
    0: isOpen,
    1: setIsOpen
  } = useState(false);
  const handleOpenChange = useCallback(open => {
    setIsOpen(open);
    onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(open);
  }, [onOpenChange]);
  const {
    refs,
    floatingStyles,
    context
  } = useFloating({
    open: isOpen,
    onOpenChange: handleOpenChange,
    placement: placement,
    whileElementsMounted: autoUpdate,
    middleware: [offset(12), flip(), shift()]
  }); // Responsive queries

  const isMobile = useMediaQuery({
    maxWidth: breakpoints.mobile.maxWidth
  }); // open menu on button click

  const click = useClick(context); // close menu on outside click or escape key

  const dismiss = useDismiss(context, {
    enabled: !isMobile
  });
  const {
    getReferenceProps,
    getFloatingProps
  } = useInteractions([click, dismiss]);
  return /*#__PURE__*/_jsx(DropdownContext.Provider, {
    value: {
      isOpen,
      isMobile,
      onOpenChange: handleOpenChange,
      setReference: refs.setReference,
      setFloating: refs.setFloating,
      floatingStyles,
      getReferenceProps,
      getFloatingProps
    },
    children: /*#__PURE__*/_jsx("div", {
      className: styles.container,
      children: children
    })
  });
};

const DropdownOpenButton = /*#__PURE__*/forwardRef((_ref2, forwardedRef) => {
  let {
    Component
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded);

  const {
    isOpen,
    setReference,
    getReferenceProps
  } = useContext(DropdownContext);
  const composedRef = useComposedRefs(forwardedRef, setReference);
  const ComponentType = Component || Button;
  return /*#__PURE__*/_jsx(ComponentType, _objectSpread(_objectSpread({
    ref: composedRef,
    isOpen: isOpen
  }, props), getReferenceProps()));
});
DropdownOpenButton.displayName = 'DropdownOpenButton';
const DropdownMenu = /*#__PURE__*/forwardRef((_ref3, forwardedRef) => {
  let {
    children,
    className
  } = _ref3;
  const {
    isOpen,
    isMobile,
    setFloating,
    floatingStyles,
    getFloatingProps,
    onOpenChange
  } = useContext(DropdownContext);
  const composedRef = useComposedRefs(forwardedRef, setFloating); // render the menu as a Drawer on mobile

  if (isMobile) {
    return /*#__PURE__*/_jsx(Drawer, {
      open: isOpen,
      onOpenChange: onOpenChange,
      children: /*#__PURE__*/_jsx(DrawerContent, {
        children: /*#__PURE__*/_jsx("div", {
          className: clsx(styles.drawer, className),
          children: children
        })
      })
    });
  }

  if (!isOpen) return null;
  return /*#__PURE__*/_jsx(FloatingPortal, {
    children: /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
      ref: composedRef,
      className: clsx(styles.menu, className),
      style: floatingStyles
    }, getFloatingProps()), {}, {
      children: children
    }))
  });
});
DropdownMenu.displayName = 'DropdownMenu';
const DropdownMenuItem = /*#__PURE__*/forwardRef((_ref4, forwardedRef) => {
  let {
    text,
    leftIcon,
    rightIcon,
    caption,
    disabled,
    onClick
  } = _ref4;
  return /*#__PURE__*/_jsxs("button", {
    type: "button",
    ref: forwardedRef,
    className: styles.menuItem,
    disabled: disabled,
    onClick: onClick,
    children: [leftIcon ? /*#__PURE__*/_jsx("span", {
      className: styles.menuItem__icon,
      children: leftIcon
    }) : null, /*#__PURE__*/_jsxs("span", {
      className: styles.menuItem__content,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.menuItem__text,
        children: text
      }), caption ? /*#__PURE__*/_jsx("span", {
        className: styles.menuItem__caption,
        children: caption
      }) : null]
    }), rightIcon ? /*#__PURE__*/_jsx("span", {
      className: styles.menuItem__icon,
      children: rightIcon
    }) : null]
  });
});
DropdownMenuItem.displayName = 'DropdownMenuItem';

const DropdownDivider = () => {
  return /*#__PURE__*/_jsx("div", {
    className: styles.divider
  });
};

export { Dropdown, DropdownMenu, DropdownMenuItem, DropdownOpenButton, DropdownDivider };
export default Dropdown;